// Multilingual content for Atom Logos website
export const translations = {
  fr: {
    // Navigation
    nav: {
      services: 'Services',
      contact: 'Contact',
      about: 'À propos'
    },
    // Hero Section
    hero: {
      title: 'Interprétation Assermentée et Traduction',
      subtitle: 'Services professionnels d\'interprétation assermentée et de traduction entre le français, l\'ukrainien et le russe',
      cta: 'Demander un devis',
      contact: 'Nous contacter'
    },
    // Services Section
    services: {
      title: 'Nos Services',
      subtitle: 'Expertise professionnelle en traduction et interprétation',
      translation: {
        title: 'Traduction B2B',
        description: 'Solutions de traduction professionnelle pour entreprises : rapports, présentations, correspondances commerciales, contenus marketing, documentation technique et communication d\'entreprise.'
      },
      interpretation: {
        title: 'Interprétation Assermentée',
        description: 'Services d\'interprétation assermentée pour tribunaux, administrations, rendez-vous officiels, audiences juridiques et démarches administratives.'
      },
      interpreterB2B: {
        title: 'Interprète B2B',
        description: 'Services d\'interprétation professionnelle pour entreprises : réunions d\'affaires, négociations commerciales, conférences, formations et événements corporate.'
      },
      languages: {
        title: 'Langues',
        description: 'Traduction et interprétation professionnelle entre le français, l\'ukrainien et le russe.'
      }
    },
    // About Section
    about: {
      title: 'À Propos',
      content: 'ATOM LOGOS est votre partenaire de confiance pour tous vos besoins en interprétation assermentée et traduction. Nous offrons des services professionnels de haute qualité entre le français, l\'ukrainien et le russe.',
      experience: 'Traductrice et interprète assermentée',
      quality: 'Qualité garantie',
      certified: 'Certifications officielles'
    },
    // Contact Section
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Demandez un devis personnalisé pour vos besoins en traduction ou interprétation',
      name: 'Nom complet',
      email: 'Email',
      phone: 'Téléphone',
      service: 'Service souhaité',
      message: 'Message',
      send: 'Envoyer',
      selectService: 'Sélectionnez un service',
      translation: 'Traduction B2B',
      interpretationSworn: 'Interprétation assermentée',
      interpreterB2B: 'Interprète B2B',
      pricing: 'Tarifs sur demande',
      success: 'Message envoyé avec succès !',
      error: 'Erreur lors de l\'envoi du message'
    },
    // Footer
    footer: {
      company: 'ATOM LOGOS',
      contact: 'Contact',
      email: 'contact@atom-logos.fr',
      phone: '+33 (0)6 52 64 82 35',
      rights: 'Tous droits réservés',
      slogan: 'Interprétation assermentée et traduction professionnelles'
    }
  },
  uk: {
    // Navigation
    nav: {
      services: 'Послуги',
      contact: 'Контакт',
      about: 'Про нас'
    },
    // Hero Section
    hero: {
      title: 'Присяжний Усний Переклад та Переклад',
      subtitle: 'Професійні послуги присяжного усного перекладу та письмового перекладу між французькою, українською та російською мовами',
      cta: 'Запитати ціну',
      contact: 'Зв\'язатися з нами'
    },
    // Services Section
    services: {
      title: 'Наші Послуги',
      subtitle: 'Професійний досвід у письмовому та усному перекладі',
      translation: {
        title: 'Переклад для Бізнесу',
        description: 'Професійні рішення з перекладу для компаній: звітів, презентацій, ділового листування, маркетингового контенту, технічної документації та корпоративних комунікацій.'
      },
      interpretation: {
        title: 'Присяжний Усний Переклад',
        description: 'Послуги присяжного усного перекладу для судів, адміністрацій, офіційних зустрічей, юридичних слухань та адміністративних процедур.'
      },
      interpreterB2B: {
        title: 'Перекладач для Бізнесу',
        description: 'Послуги професійного усного перекладу для компаній: ділових зустрічей, комерційних переговорів, конференцій, тренінгів та корпоративних заходів.'
      },
      languages: {
        title: 'Мови',
        description: 'Професійний письмовий та усний переклад між французькою, українською та російською мовами.'
      }
    },
    // About Section
    about: {
      title: 'Про Нас',
      content: 'ATOM LOGOS - ваш надійний партнер для всіх ваших потреб у присяжному усному перекладі та письмовому перекладі. Ми пропонуємо професійні послуги високої якості між французькою, українською та російською мовами.',
      experience: 'Присяжний усний перекладач',
      quality: 'Гарантована якість',
      certified: 'Офіційні сертифікати'
    },
    // Contact Section
    contact: {
      title: 'Зв\'яжіться з Нами',
      subtitle: 'Запитайте персональну ціну для ваших потреб у перекладі',
      name: 'Повне ім\'я',
      email: 'Електронна пошта',
      phone: 'Телефон',
      service: 'Бажана послуга',
      message: 'Повідомлення',
      send: 'Надіслати',
      selectService: 'Виберіть послугу',
      translation: 'Переклад для бізнесу',
      interpretationSworn: 'Присяжний усний переклад',
      interpreterB2B: 'Перекладач для бізнесу',
      pricing: 'Ціни за запитом',
      success: 'Повідомлення успішно надіслано!',
      error: 'Помилка при відправці повідомлення'
    },
    // Footer
    footer: {
      company: 'ATOM LOGOS',
      contact: 'Контакт',
      email: 'contact@atom-logos.fr',
      phone: '+33 (0)6 52 64 82 35',
      rights: 'Всі права захищені',
      slogan: 'Присяжний усний переклад та професійний письмовий переклад'
    }
  },
  ru: {
    // Navigation
    nav: {
      services: 'Услуги',
      contact: 'Контакт',
      about: 'О нас'
    },
    // Hero Section
    hero: {
      title: 'Присяжный Устный Перевод и Перевод',
      subtitle: 'Профессиональные услуги присяжного устного перевода и письменного перевода между французским, украинским и русским языками',
      cta: 'Запросить цену',
      contact: 'Связаться с нами'
    },
    // Services Section
    services: {
      title: 'Наши Услуги',
      subtitle: 'Профессиональный опыт в письменном и устном переводе',
      translation: {
        title: 'Перевод для Бизнеса',
        description: 'Профессиональные решения по переводу для компаний: отчетов, презентаций, деловой переписки, маркетингового контента, технической документации и корпоративных коммуникаций.'
      },
      interpretation: {
        title: 'Присяжный Устный Перевод',
        description: 'Услуги присяжного устного перевода для судов, администраций, официальных встреч, юридических слушаний и административных процедур.'
      },
      interpreterB2B: {
        title: 'Переводчик для Бизнеса',
        description: 'Услуги профессионального устного перевода для компаний: деловых встреч, коммерческих переговоров, конференций, тренингов и корпоративных мероприятий.'
      },
      languages: {
        title: 'Языки',
        description: 'Профессиональный письменный и устный перевод между французским, украинским и русским языками.'
      }
    },
    // About Section
    about: {
      title: 'О Нас',
      content: 'ATOM LOGOS - ваш надежный партнер для всех ваших потребностей в присяжном устном переводе и письменном переводе. Мы предлагаем профессиональные услуги высокого качества между французским, украинским и русским языками.',
      experience: 'Присяжный устный переводчик',
      quality: 'Гарантированное качество',
      certified: 'Официальные сертификаты'
    },
    // Contact Section
    contact: {
      title: 'Свяжитесь с Нами',
      subtitle: 'Запросите персональную цену для ваших потребностей в переводе',
      name: 'Полное имя',
      email: 'Электронная почта',
      phone: 'Телефон',
      service: 'Желаемая услуга',
      message: 'Сообщение',
      send: 'Отправить',
      selectService: 'Выберите услугу',
      translation: 'Перевод для бизнеса',
      interpretationSworn: 'Присяжный устный перевод',
      interpreterB2B: 'Переводчик для бизнеса',
      pricing: 'Цены по запросу',
      success: 'Сообщение успешно отправлено!',
      error: 'Ошибка при отправке сообщения'
    },
    // Footer
    footer: {
      company: 'ATOM LOGOS',
      contact: 'Контакт',
      email: 'contact@atom-logos.fr',
      phone: '+33 (0)6 52 64 82 35',
      rights: 'Все права защищены',
      slogan: 'Присяжный устный перевод и профессиональный письменный перевод'
    }
  }
};
